export default {
  Brown: '#704f0c',
  Blue: '#0470c0',
  Red: '#ae040c',
  Green: '#44a116',
  Black: '#000000',
  White: '#ffffff',
  Tan: '#c39d69',
  Yellow: '#fefe00',
  Silver: '#a4a5a5',
  Purple: '#3b00a7',
  'Dark Green': '#045600',
  Orange: '#ff8c00',
}
